<template>
  <a-modal
    title="Confirmation"
    :visible="modalEdit"
    @ok="handleModalEditOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
  >
    <loading v-if="anggaran.loadingtree" />
    <template slot="footer">
        <a-button key="back" @click="handleCancel">
          Cancel
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleModalEditOk">
          Submit
        </a-button>
      </template>
    <a-form :form="formEditModal">
      <a-form-item label="Description">
        <a-input
          v-decorator="['deskripsi', {rules: [{required: true}], initialValue: data.deskripsi}]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Jenis Anggaran">
        <a-select
          showSearch
          v-decorator="[
              'jns_anggaran_id',
              {
                rules: [{ required: true }], initialValue: data.jns_anggaran_id,
              },
            ]"
          @change="handleJenisAnggaran"
        >
          <a-select-option v-for="item in getJenisAnggaran" :key="item.value">
            {{
            item.text
            }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Cost Center">
        <a-select
          showSearch
          ref="costCntr"
          v-decorator="[
                    'cost_center',
                    {
                        rules: [{ required: true }],
                         initialValue:data.cost_center_id
                    },
                    ]"
          @change="handle_Cost"
        >
          <a-select-option v-for="item in costCenter" :key="item.value">
            {{
            item.text
            }} ({{item.nama_pekerjaan ? item.nama_pekerjaan : '-'}})
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Peruntukan">
        <a-select
          showSearch
          v-decorator="[
                    'peruntukan',
                    {
                        rules: [{ required: true }],
                        initialValue:data.peruntukan_id
                    },
                    ]"
          @change="handle_Peruntukan"
          ref="refperuntukan"
          optionFilterProp="children"
          :filterOption="filterOption"
        >
          <a-select-option v-for="item in peruntukan" :key="item.value">
            {{
            item.text
            }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- <a-form-item label="Sub Peruntukan">
          <a-select
            :disabled="subPeruntukan.length == 0"
            showSearch
            v-decorator="[
              'sub_peruntukan',
              {
                rules: [{ required: true }],
                initialValue:data.sub_peruntukan_id
              },
            ]"
            @change="handle_SubPeruntukan"
            ref="refsub_peruntukan"
            optionFilterProp="children"
            :filterOption="filterOption"
          >
            <a-select-option v-for="item in subPeruntukan" :key="item.value">{{
              item.text
            }}</a-select-option>
          </a-select>
      </a-form-item>-->
      <a-form-item label="Kode Anggaran">
        <!-- <a-select
            :disabled="anggaran.length == 0"
            showSearch
            v-decorator="[
              'kode_anggaran',
              {
                rules: [{ required: true }],
                initialValue:data.kode_anggaran_id
              },
            ]"
            ref="kode_anggaran"
            optionFilterProp="children"
            :filterOption="filterOption"
          >
            <a-select-option v-for="item in anggaran" :key="item.value">{{
              item.text
            }}</a-select-option>
        </a-select>-->
        <a-tree-select
          v-decorator="['kode_anggaran', {rules: [{required: true}],initialValue: data.anggaran_code}]"
          show-search
          style="width: 100%"
          @select="handlechoiceCost"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="anggaran.tree"
          treeNodeFilterProp="children"
          :filterTreeNode="filterTreeNode"
          placeholder="Please select"
          :treeExpandedKeys="treeExpandedKeys"
          allow-clear
          :disabled="anggaran.loadingtree || anggaran.tree==undefined || anggaran.tree.length==0"
          tree-default-expand-all
        >
          <span slot="title" slot-scope="item">
            <table style="width:100%">
              <tr>
                <td>
                  <span>{{item.texttitle}} - {{item.kode_anggaran}}</span>
                </td>
                <td>
                  <span style="float:right">{{formatRupiah(parseFloat(item.rekap))}}</span>
                </td>
              </tr>
            </table>
          </span>
        </a-tree-select>
      </a-form-item>

      <a-form-item label="Activity Type" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV')">
        <a-select placeholder="Please Select" 
        ref="refactivity_type"
        v-decorator="[
          'activity_type',
          { rules: [{ required: true }], initialValue: data.activity_type },
        ]"
        disabled
        @change="changeActivity_type" class="width-full">
          <a-select-option v-for="item in getMARDEVActivity.type" :key="item">
            {{item}}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Pipeline" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV') && $refs.refactivity_type && $refs.refactivity_type.value=='Project Penetration'">
        <a-select
          showSearch
          :loading="load.pipeline"
          :not-found-content="null"
          option-filter-prop="children"
          v-decorator="[
            'pipeline_id',
            {
              rules: [{ required: true }], initialValue: data.pipeline_id
            },
          ]"
          disabled
        >
          <a-select-option v-for="item in pipelineList" :key="item.pipeline_id">
            [{{ item.pipeline_no}}] {{ item.definitions }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Activity" v-if="1==0 && $refs.costCntr && $refs.costCntr.value && $refs.costCntr.value.includes('MARDEV') && $refs.refactivity_type && $refs.refactivity_type.value=='Non Project'">
        <a-select placeholder="Please Select" 
        v-decorator="[
          'activity',
          { rules: [{ required: true }], initialValue: data.activity },
        ]" disabled class="width-full">
          <a-select-option v-for="item in getMARDEVActivity.activity" :key="item">
            {{item}}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="Credit">
        <a-input-number
          :min="0"
          @keydown="onlyNumber"
          class="m-width-full m-text-align-right"
          :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="value => value.replace(/\Rp\s?|(,*)/g, '')"
          v-decorator="['kredit', {rules: [{required: true},{validator:checkPrice}], initialValue: data.kredit}]"
        />
      </a-form-item>

      <a-form-item label="Expense Date">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          v-decorator="['tanggal_pengeluaran', {rules: [{required: true}],
                initialValue: moment(data.tanggal_pemakaian)}]"
        />
      </a-form-item>

      <a-form-item label="End User">
        <a-select
          showSearch
          allowClear
          ref="fendusermodal"
          :filter-option="filterOptionTlc"
          option-filter-prop="children"
          v-decorator="['end_user', 
          { 
              rules: [{ required: true }],
              initialValue: data.end_user,
          }]"
          disabled
          @change="changeenduser"
        >
          <a-select-option v-for="user in getEndUserCC" :key="user.id_user_cc"
                  >{{ user.nama }} ({{user.type_cc}} / {{ formatRupiah(user.limit_kredit) }})</a-select-option
                >
        </a-select>
      </a-form-item>

      <a-form-item label="Prospect No" v-if="selectedCostCenter=='07'">
        <a-select
          showSearch
          :allowClear="(getTlc_CEO==end_user_klaim ? true : false)"
          :not-found-content="null"
          option-filter-prop="children"
          v-decorator="[
            'prospek',
            {
              rules: [{ required: (getTlc_CEO==end_user_klaim ? false : true) }], initialValue: data.prospek
            },
          ]"
        >
          <a-select-option
            v-for="item in listProspect"
            :key="item.id_prospek"
          >
            {{ item.no_prospek }} - {{ item.description }}
          </a-select-option>
        </a-select>
      </a-form-item>
      
      <a-row :gutter="12">
        <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
          <a-form-item label="Is Commission?">
            <a-radio-group
              v-decorator="[
                'iscommision',
                { rules: [{ required: false }], initialValue: data.iscommision },
              ]"
              @change="handleOptionCommission"
              :disabled="EnCommission"
              button-style="solid"
            >
              <a-radio-button value="1"> Yes </a-radio-button>
              <a-radio-button value="0"> No </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
          <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
            <a-form-item label="With Note?" :hidden="true">
            <a-radio-group
              v-decorator="[
                'without_note',
                { rules: [{ required: false }], initialValue: data.without_note },
              ]"
              button-style="solid"
            >
              <a-radio-button value="0"> Yes </a-radio-button>
              <a-radio-button value="1"> No </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item label="Upload Transaction Document">
        <a-upload
          :showUploadList="true"
          :fileList="doctransfiles"
          :beforeUpload="beforedoctransUpload"
          :remove="handledoctransRemove"
          v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
        >
          <a-button>
            <a-icon type="upload" />&nbsp;Select File
          </a-button>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Loading from "@/components/preloader/Loading.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  props: {
    dataList: {},
    confirmLoading: Boolean,
    modalEdit: Boolean,
    data: {},
    getCostCenter: {},
    getPeruntukan: {},
    getSubPeruntukan: {},
    getAnggaran: {},
  },
  mixins: [CurrencyFormat,GlobalMethod],
  components: {
    Loading,
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getAuth",
      "getActiveProjectkk",
      "getAlokasi",
      "getUsedFor",
      "getJenisAnggaran",
      "getEndUserCC",
      "getMARDEVActivity",
      "getTlc_CEO"
    ]),
    project() {
      return this.getActiveProjectkk.filter((obj) => obj.kategori);
    },
    end_user_klaim(){
      return this.enduser_tlc ? this.enduser_tlc : this.data.end_user
    }
  },
  data() {
    return {
      loading: false,
      kategori: "",
      peruntukan: [],
      subPeruntukan: [],
      costCenter: [],
      anggaran: {
        peruntukan_id: "",
        anggaran_id: "",
        id_pp: "",
        modalvalue: undefined,
        path: "",
        limit: 0,
        tree: [],
        treeModal: [],
        searchValue: "",
        loadingtree: false,
      },
      treeExpandedKeys: [],
      EnCommission: false,
      Viwithout_note: false,
      doctransfiles: [],
      pipelineList: [],
      load:{
        pipeline: false
      },
      activity_type: null,
      activity: null,
      selectedCostCenter: null,
      listProspect: [],
      enduser_tlc: null
    };
  },
  created() {
    this.$store.dispatch("FETCH_ENDUSER_CC");
    this.formEditModal = this.$form.createForm(this);
    if (this.getPeruntukan !== undefined) {
      if(this.data.cost_center_id){
      const peruntukan = this.getPeruntukan.filter(
        (obj) =>
          obj.anggaran_id
            .toLowerCase()
            .indexOf(this.data.cost_center_id.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;
      }else{
        this.peruntukan = {};
      }
    }
    if (this.getSubPeruntukan !== undefined) {
      if(this.data.peruntukan_id){
      const filter = this.getSubPeruntukan.filter(
        (obj) =>
          obj.peruntukan_id
            .toLowerCase()
            .indexOf(this.data.peruntukan_id.toLowerCase()) >= 0
      );
      this.subPeruntukan = filter;
      }else{
        this.subPeruntukan = {}
      }
    }

    let filtera = {};
    if (this.getAnggaran !== undefined) {
      if(this.data.sub_peruntukan_id){
        filtera = this.getAnggaran.filter(
          (obj) =>
            obj.anggaran_dtl_id
              .toLowerCase()
              .indexOf(this.data.sub_peruntukan_id.toLowerCase()) >= 0
        );
      }
      //this.anggaran = filtera;
    }
    if (this.getCostCenter !== undefined) {
      if(this.data.cost_center_id){
        filtera = this.getCostCenter.filter(
          (obj) =>
            obj.value
              .toLowerCase()
              .indexOf(this.data.cost_center_id.toLowerCase()) >= 0
        );
      }

      this.costCenter = filtera;
    }
  },
  async mounted() {
    await this.initialPipeline(this.data.cost_center_id)
    this.getTreeAnggaran(this.data.anggaran_code!==undefined);
      this.EnCommission = this.data.EnCommission;
      this.Viwithout_note = this.data.Viwithout_note;
      this.doctransfiles = this.data.doctransfiles;
    this.selectedCostCenter = this.data.jns_anggaran_id
    this.anggaran.anggaran_id = this.data.cost_center_id
  },
  watch:{
    data(){
      if(this.data.id){
        this.EnCommission = this.data.EnCommission;
        this.Viwithout_note = this.data.Viwithout_note;
        this.doctransfiles = this.data.doctransfiles;
      }
    }
  },
  methods: {
    moment,
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    // recountAnggaran(arr) {
    //   arr = arr.filter((obj) => obj.path !== "");
    //   if (arr.length > 0) {
    //     //restore nominal ke origin
    //     //console.log("pertama")
    //     arr.forEach((elm) => {
    //       if(elm.path){
    //         let ObjVal = elm.path.split(";");
    //         let path1 = "";
    //         let path2 = "";
    //         let path3 = "";
    //         let trigerpath = true;
    //         let tempTree = this.anggaran.tree;
    //         ObjVal.forEach((element) => {
    //           if (path1 == "") {
    //             path1 += "tempTree[" + element + "]";
    //             path3 = path1;
    //           } else {
    //             path3 = path1 + ".children";
    //             path1 += ".children[" + element + "]";
    //           }
    //           if (trigerpath) {
    //             if (!eval(path3)) {
    //               trigerpath = false;
    //               return;
    //             } else {
    //               if (!eval(path1)) {
    //                 trigerpath = false;
    //                 return;
    //               }
    //             }
    //           }
    //         });

    //         if (trigerpath) {
    //           path2 = eval(path1 + ".origin_rekap");
    //           eval(path1 + ".rekap=" + path2);
    //           //eval(path1+".disabled=false")
    //         }
    //       }
    //     });
    //     //menghitung nominal dengan acuan nominal origin
    //     arr.forEach((elem) => {
    //       if(elem.path){
    //         let ObjVal = elem.path.split(";");
    //         let path = "";
    //         let tpath = "";
    //         let trigerpath = true;
    //         let tempTree = this.anggaran.tree;
    //         ObjVal.forEach((element) => {
    //           if (path == "") {
    //             path += "tempTree[" + element + "]";
    //             tpath = path;
    //           } else {
    //             tpath = path + ".children";
    //             path += ".children[" + element + "]";
    //           }
    //           if (trigerpath) {
    //             if (!eval(tpath)) {
    //               trigerpath = false;
    //               return;
    //             } else {
    //               if (!eval(path)) {
    //                 trigerpath = false;
    //                 return;
    //               }
    //             }
    //           }
    //         });
    //         if (trigerpath) {
    //           let kd_anggrn = eval(path + ".kode_anggaran");
    //           if (kd_anggrn == elem.kode_anggaran) {
    //             let oldVal = eval(path + ".rekap");
    //             let num = oldVal - parseFloat(elem.kredit);
    //             //let exe = path+".rekap="+ num
    //             //eval(exe)
    //             if (num <= 0) {
    //               eval(path + ".disabled=true");
    //             } else {
    //               eval(path + ".disabled=false");
    //             }
    //           }
    //         }
    //         this.anggaran.tree = tempTree;
    //       }
    //     });

    //     if(this.data.path){
    //       let ObjVal = this.data.path.split(";");
    //       let path = "";
    //       let tpath = "";
    //       let trigerpath = true;
    //       let tempTree = this.anggaran.tree;
    //       ObjVal.forEach((element) => {
    //         if (path == "") {
    //           path += "tempTree[" + element + "]";
    //           tpath = path;
    //         } else {
    //           tpath = path + ".children";
    //           path += ".children[" + element + "]";
    //         }
    //         if (trigerpath) {
    //           if (!eval(tpath)) {
    //             trigerpath = false;
    //             return;
    //           } else {
    //             if (!eval(path)) {
    //               trigerpath = false;
    //               return;
    //             }
    //           }
    //         }
    //       });
    //       if (trigerpath) {
    //         let oldVal = eval(path + ".rekap");
    //         let num = oldVal + parseFloat(this.data.kredit);
    //         let exe = path + ".rekap=" + num;
    //         eval(exe);
    //         if (num <= 0) {
    //           eval(path + ".disabled=true");
    //         }
    //       }
    //     }
    //   }
    // },
    async getTreeAnggaran(getloading) {
      //console.log(this.data)
      if(getloading){
      this.anggaran.loadingtree = true;
      }
      let dataParams = {
        anggaran_id: this.data.cost_center_id,
        tlc: this.getAuth.username,
        peruntukan_id: this.data.peruntukan_id,
        id_klaim: this.data.id_klaim,
        id_klaim_dtl: this.data.id,
      };
      //console.log("modal dataParams",dataParams)
      if (dataParams.peruntukan_id) {
        await axios({
          method: "get",
          url: this.$serviceUrl + "klaim_cc/tree_anggaran",
          params: dataParams,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.anggaran.tree = response.data.tree;
            this.anggaran.treeModal = [
              ...this.anggaran.treeModal,
              response.data.tree[0],
            ];
            
            let dt = this.dataList.filter((item) => item.kredit != "");
            this.treeExpandedKeys = this.getParent(this.anggaran.treeModal);
            //this.recountAnggaran(dt);

            if(this.selectedCostCenter=='07'){
              this.getProspectList();
            }else{
              this.anggaran.loadingtree = false;
            }
          })
          .catch((err) => {
            this.anggaran.loadingtree = false;
            //let responses = Object.assign({}, err.response);
            //console.log("error",responses,err)
            this.displayMessageValue("error", err);
          });
      }
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handlechoiceCost(value, record) {
      this.data.limit = record.dataRef.rekap;
      this.data.path = record.dataRef.path;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async handle_Cost(e) {
      await this.initialPipeline(e)
      //console.log("jos")
      this.$nextTick(function () {
        //this.formEditModal.resetFields(["peruntukan", "sub_peruntukan", "kode_anggaran"]);
        this.formEditModal.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.subPeruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      const peruntukan = this.getPeruntukan.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.peruntukan = peruntukan;
      this.anggaran.anggaran_id = e;
      this.data.cost_center_id = e;
    },
    handle_Peruntukan(e) {
      //console.log("handleEdit",e)
      this.$nextTick(function () {
        //this.formEditModal.resetFields(["sub_peruntukan", "kode_anggaran"]);
        this.formEditModal.setFieldsValue({
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      this.anggaran.peruntukan_id = e;
      this.data.peruntukan_id = e;
      const filter = this.getSubPeruntukan.filter(
        (obj) => obj.peruntukan_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.subPeruntukan = filter;
      this.getTreeAnggaran(true);
      let arr = this.dataList.filter((item) => item.kredit !== "");
      //this.recountAnggaran(arr);
    },
    handle_SubPeruntukan(e) {
      this.$nextTick(function () {
        //this.formEditModal.resetFields(["kode_anggaran"]);
        this.formEditModal.setFieldsValue({
          kode_anggaran: null,
        });
      });
      const filter = this.getAnggaran.filter(
        (obj) => obj.anggaran_dtl_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      //this.anggaran = filter;
    },
    handleCancel(e) {
      Event.$emit("modalCancel", false);
      this.formEditModal.resetFields();
      //console.log(this.$refs)
      Event.$emit("resetdtlpemakaian", true);
    },
    handleModalEditOk() {
      this.formEditModal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if(moment(values.tanggal_pengeluaran).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Expense date can't exceed today!");
          return;
        }

        //antisipasi error bigint postgresql
        if (this.dataList.length > 0) {
          let nom = (10 * parseFloat(this.dataList[0].debit)) / 100;
          if (values.kredit > nom) {
            this.displayMessageValue(
              "error-other",
              "The value max is 10% from debet!"
            );
            return;
          }
        }

        //console.log(values)
        if (parseFloat(this.data.limit) < values.kredit) {
          this.displayMessageValue(
            "limit-anggaran",
            this.formatRupiah(this.data.limit)
          );
          return;
        } else {
          this.loading = true;
          let url =
            this.data.type === "revised"
              ? "klaim_cc/revisi_klaim_cc_dtl_edit"
              : "klaim_cc/klaim_cc_dtl_draft_edit";
          let kd = values.kode_anggaran.split(";");

          let addData = new FormData();
          addData.append("tlc", this.getAuth.username);
          addData.append("id", this.data.id);
          addData.append("id_klaim", this.data.id_klaim);
          addData.append("tanggal_pengeluaran", values.tanggal_pengeluaran.format("YYYY-MM-DD"));
          addData.append("deskripsi", values.deskripsi);
          addData.append("project", values.proyek);
          addData.append("allocation", values.alokasi);
          addData.append("kredit", values.kredit);
          addData.append("cost_center", values.cost_center);
          addData.append("peruntukan", values.peruntukan);
          addData.append("sub_peruntukan", kd[kd.length - 2]);
          addData.append("kode_anggaran", kd[kd.length - 1]);
          addData.append("anggaran_dtl_val_id", kd[kd.length - 1]);
          addData.append("jns_anggaran_id", values.jns_anggaran_id);
          addData.append("path", this.data.path);
          addData.append("id_user_cc", values.end_user);
          addData.append("iscommision", values.iscommision);
          //addData.append("without_note", values.without_note);
          addData.append("without_note", "1");
          if(values.pipeline_id)
          addData.append("pipeline", values.pipeline_id);
          if(values.activity)
          addData.append("activity", values.activity);
          if(values.activity_type)
          addData.append("activity_type", values.activity_type);

          if (this.doctransfiles && this.doctransfiles.length > 0) {
            this.doctransfiles.forEach((file) => {
              addData.append("file_upload", file);
            });
          }

          if (values.prospek) {
            addData.append("prospek", values.prospek);
          }

          axios({
            method: "post",
            url: this.$serviceUrl + url,
            processData: false,
            data: addData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              // "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.loading = false;
              this.formEditModal.resetFields();
              Event.$emit("modalCancel", false);
              Event.$emit("fetchPemakaian", true);
              Event.$emit("resetdtlpemakaian", true);
            })
            .catch((err) => {
              this.loading = false;
              Event.$emit("resetdtlpemakaian", true);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              console.log("error : " + err);
            });
        }
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    handleProyek(value) {
      let filter = this.project.filter(
        (obj) =>
          obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      this.kategori = filter[0].kategori;
      this.formEditModal.setFieldsValue({
        alokasi: "",
      });
    },
    handleJenisAnggaran(e) {
      this.selectedCostCenter = e
      this.data.prospek = null
      this.listProspect = []
      this.formEditModal.setFieldsValue({
        cost_center: null,
        peruntukan: null,
        sub_peruntukan: null,
        kode_anggaran: null,
        prospek: null
      });
      const filter = this.getCostCenter.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.costCenter = filter;
      this.peruntukan = [];
      this.anggaran.tree = [];
      this.anggaran.treeModal = [];
      this.subPeruntukan = [];
    },
    filterOptionTlc(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formEditModal.setFieldsValue({
            without_note: "1",
        });
      });
    },
    handleChangeumDtl(val){
      let selectedumDtl = _.filter(this.data.ppdetillist, { id_um_dtl: val });
      //console.log(selectedumDtl,this.ppdetillist);
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEditModal.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEditModal.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
    async initialPipeline(e){
      this.load.pipeline = true
      await axios({
        method: "get",
        url: this.$serviceUrl + "klaim_direktur/pipeline",
        params: {
          anggaran_id: e,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then((response) => {
        this.load.pipeline = false
        this.pipelineList = response.data.data?response.data.data:[]
      })
      .catch((err) => {
        let responses = Object.assign({}, err.response);
        this.displayMessageValue("error", responses);
      });
    },
    changeActivity_type(val){
      if(val=="Non Project"){
        this.data.activity = null
        this.$nextTick(function () {
          this.formEditModal.setFieldsValue({
            activity: null,
          });
        });
      }else{
        this.data.pipeline_id = null
        this.$nextTick(function () {
          this.formEditModal.setFieldsValue({
              pipeline_id: null,
          });
        });
      }
    },
    async getProspectList(){
      await axios({
        method: "get",
        url: this.$serviceUrl + "prospek/pilih_prospek",
        params: {
          anggaran_id: this.anggaran.anggaran_id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
      .then(async (response) => {
        this.listProspect = response.data.data ? response.data.data : [];
        this.anggaran.loadingtree = false;
      })
      .catch(() => {
      });
    },
    changeenduser(val){
      this.enduser_tlc = val
    }
  },
};
</script>

<style>
</style>